import { LOADING_IMAGES } from './flightLoading.data';
import { preloadLoadingImages } from './loading.preload';

let warmPromise = null;

/** App-level warm preload — flight/train/hotel share these WebPs today. */
export function warmVerticalLoaderImages() {
  if (!warmPromise) {
    warmPromise = preloadLoadingImages(LOADING_IMAGES);
  }
  return warmPromise;
}
